// src/components/Hero/Hero.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Hero.css';

// Fotoğraflarını buradan import ediyoruz (assets klasöründe olduklarını varsayarak)
import hero1 from '../../assets/hero1.jpg';
import hero2 from '../../assets/hero2.jpg';
import hero3 from '../../assets/hero3.jpg'; // Kaç tane varsa ekleyebilirsin

function Hero() {
  // Fotoğrafları bir dizide tutuyoruz
  const images = [hero1, hero2, hero3];
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // 3 saniyede bir görseli değiştiren zamanlayıcı (slider)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // 3000 = 3 saniye

    // Bileşen kapandığında zamanlayıcıyı temizliyoruz
    return () => clearInterval(interval);
  }, [images.length]);

  // Çalışma alanlarına smooth scroll yapma fonksiyonu kanka
  const handleScrollToServices = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/?scrollTo=services');
    } else {
      const servicesElement = document.getElementById('services-section');
      if (servicesElement) {
        servicesElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="hero-container">
      
      {/* Slider Görselleri - Arka planda değişen kısım */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-bg ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}

      {/* Rengi açılmış arka plan filtresi */}
      <div className="hero-overlay"></div>
      
      {/* Ana İçerik */}
      <div className="hero-content">
        <h1 className="hero-title">
          Adaletin Gücü, <br />
          <span className="gold-text">Güvenin Teminatı</span>
        </h1>
        <p className="hero-description">
          Av. Emre Uygun Hukuk ve Danışmanlık Bürosu olarak, haklarınızı en güçlü şekilde savunuyor, hukuki süreçlerinizi şeffaflıkla yönetiyoruz.
        </p>
        
        <div className="hero-btn-group">
          {/* İletişim sayfasına yönlendiren buton */}
          <Link to="/iletisim" className="btn-gold" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Hemen İletişime Geçin
          </Link>
          
          {/* Çalışma alanlarına kaydıran buton kanka */}
          <a href="#services-section" onClick={handleScrollToServices} className="btn-outline" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Çalışma Alanlarımız
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;